import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MainLayoutComponent } from 'projects/suche-lib/src/lib/components/main-layout/main-layout.component';
import { ErrorService } from 'projects/suche-lib/src/lib/services/error/error.service';
import { CleanupService } from 'projects/suche-lib/src/lib/shared/utils/cleanup.service';
import { ModalPopupComponent } from 'projects/suche-lib/src/projects';
import { map } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { BackToTopButtonComponent } from './components/back-to-top-button/back-to-top-button.component';
import { OiamOauthComponent } from './components/oiam-oauth/oiam-oauth.component';
import { VersionComponent } from './components/version/version.component';
import { CanonicalUrlService } from './service/canonical-url.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'now-wbsuche-app-root',
  templateUrl: './app.component.html',
  imports: [
    CommonModule,
    MainLayoutComponent,
    RouterOutlet,
    BackToTopButtonComponent,
    OiamOauthComponent,
    VersionComponent,
    ModalPopupComponent
  ],
  providers: [CleanupService]
})
export class AppComponent implements OnInit {
  private readonly errorService = inject(ErrorService);
  private readonly router = inject(Router);
  private readonly canonicalUrlService = inject(CanonicalUrlService);
  private readonly cleanupService = inject(CleanupService);

  title = 'suche-app';

  @ViewChild('errorModal')
  private readonly errorModal!: ModalPopupComponent;

  public keyboardMode = false;

  private readonly elRef = inject(ElementRef);

  @HostListener('keydown')
  keydown(): void {
    this.keyboardMode = true;
  }

  @HostListener('mousedown')
  mousedown(): void {
    this.keyboardMode = false;
  }

  ngOnInit(): void {
    if (environment.production) {
      // https://confluence.webapp.sdst.sbaintern.de/display/SICHARC/M-114+Verbergen+interner+Informationen
      // remove angular version info disclosure html tag.
      this.elRef.nativeElement.removeAttribute('ng-version');
    }

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event) => event),
        takeUntil(this.cleanupService.destroyed$)
      )
      .subscribe(() => {
        // Aktualisiere nach jeder Navigation die kanonische URL.
        this.canonicalUrlService.updateCanonicalUrl();
      });

    this.errorService.errorEvent$
      .pipe(
        takeUntil(this.cleanupService.destroyed$),
        tap(() => this.errorModal.openModal())
      )
      .subscribe();
  }
}
